// TODO: 프로모션 종료 후 삭제
import { isDateInRange } from '~/lib/datetime';

export const checkPromotionSchedule = (startDate: string, endDate: string) => {
  return isDateInRange({ startDate, endDate, includeStart: true, includeEnd: true });
};
